<template>
  <div class="inner"
    :data-mods="itemData.mods"
    :data-responsive="moduleResponsive"
    :style="setBasicStyle">
    <!-- overlay dimm -->
    <div v-if="itemSetting.layout.background.value !== '' && itemSetting.layout.background.overlay"
      class="moduleInner"
      :style="{backgroundColor: itemSetting.layout.background.color}" />
    <!-- //overlay dimm -->
    <!-- 스탠다드 레이아웃에 안맞는 특정모듈 -->
    <div v-if="itemData.extra && typeof (itemData.extra) !== 'undefined'" class="module"
      :data-column_padding_lr="itemSetting.layout.columns && itemSetting.layout.columns.padding.lr"
      :data-max_width="itemSetting.layout.activeMaxWidth && itemSetting.layout.maxWidth ? itemSetting.layout.maxWidth : null"
      :style="{maxWidth: getMaxWidth}">
      <!-- datetime -->
      <div v-if="itemData.mods === 'datetime'" style="width: 100%;">
        <DatetimeModule
          :isNew="isNew"
          :itemData="itemData"
          :activeLang="activeLang"
          :itemSetting="itemSetting"
          @setDetail="setDetails" />
      </div>
      <!-- //datetime -->
      <!-- datetime -->
      <div v-if="itemData.mods === 'smartkey'" class="t11111" style="width: 100%;">
        <SmartkeyModule
          :locale="locale"
          :isNew="isNew"
          :itemData="itemData"
          :activeLang="activeLang"
          :itemSetting="itemSetting"
          @setDetail="setDetails" />
      </div>
      <!-- //datetime -->
    </div>
    <!-- //스탠다드 레이아웃에 안맞는 특정모듈 -->
    <!-- 스탠다드 레이아웃 -->
    <!-- 컬럼 for loof :: 각 컬럼별 데이터에 따라 지정한 타입으로 렌더함 -->
    <draggable v-if="!itemData.extra" class="module"
      :data-column_padding_lr="itemSetting.layout.columns && itemSetting.layout.columns.padding.lr"
      :data-max_width="itemSetting.layout.activeMaxWidth && itemSetting.layout.maxWidth ? itemSetting.layout.maxWidth : null"
      :style="moduleStyle(itemSetting.layout.flex || itemSetting.layout.columns)"
      v-model="columns"
      :animation="200"
      :class="getColumnMinWidth && 'wideScrollbar'"
      handle=".handleColumn .handleMove">
      <div class="column setbox"
        v-for="item in columns"
        :class="{columnBreak: item.type === 'break'}"
        :key="`${id}_${item.columnId}`"
        :style="columnStyle(item)">
        <div class="handleColumn">
          <button type="button" class="handle setDetail"
            v-if="typeof (item.detail) !== 'undefined'"
            @click="setDetail($event, item.detail)">
          </button>
          <button type="button" class="handle handleMove"
            v-if="columns.length > 1">
          </button>
          <button type="button" class="handle delColumn"
            v-if="itemData.mods === 'flexible'"
            @click="deleteColumn(item.columnId)">
          </button>
          {{itemData.mods}}
        </div>
        <Mods
          v-if="item"
          :isNew="isNew"
          :id="id"
          :moduleIndex="moduleIndex"
          :item="item"
          :activeLang="activeLang"
          :locale="locale"
          :itemSetting="itemSetting"
          :hasPrice="hasPrice"
          :subOption="subOption"
          @setDetail="setDetails" />
      </div>
    </draggable>
    <!-- //컬럼 for loof -->
    <!-- flexible -->
    <Flexible v-if="itemData.mods === 'flexible'"
      :isNew="isNew"
      :id="id"
      :moduleIndex="moduleIndex"
      :activeLang="activeLang"
      :locale="locale"
      :itemColumn="itemData.column"
      :itemSetting="itemSetting"
      :hasPrice="hasPrice"
      @setColumn="setColumn">
    </Flexible>
    <!-- //flexible -->
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Mods from '@/components/Editor/Modules/Index.vue'
import DatetimeModule from '@/components/Editor/Modules/Datetime.vue'
import SmartkeyModule from '@/components/Editor/Modules/Smartkey.vue'
import Flexible from '@/components/Editor/Modules/Flexible.vue'
import UTIL from '@/common/util'
import UNIQUE from '@/common/unique'
import moduleDetail from '@/components/Editor/columnDetail'

export default {
  props: [
    'moduleList',
    'moduleListAll',
    'activeLang',
    'id',
    'isNew',
    'moduleIndex',
    'hasPrice',
    'resizable',
    'itemData',
    'columnData',
    'itemSetting',
    'linkHref',
    'resource',
    'subOption'
  ],
  components: {
    draggable,
    Mods,
    DatetimeModule,
    SmartkeyModule,
    Flexible
  },
  computed: {
    locale () {
      return this.$store.state.service.locale.data
    },
    moduleResponsive () {
      let responsive = 'mobile'
      if (this.id.includes('tablet')) {
        responsive = 'tablet'
      }
      return responsive
    },
    getMaxWidth () {
      const layout = this.itemSetting.layout
      const isActive = layout.activeMaxWidth
      const maxWidth = isActive
        ? layout.maxWidth === 'input'
          ? layout.maxWidthInput ? `${layout.maxWidthInput}px` : '100%'
          : `${layout.maxWidth}%`
        : null
      return maxWidth
    },
    getColumnStretch () {
      const layout = this.itemSetting.layout
      const isActive = layout.columns.stretch
      const maxWidth = isActive
        ? `${layout.maxWidthInput}px`
        : null
      return maxWidth
    },
    getColumnMinWidth () {
      const layout = this.itemSetting.layout
      const isActive = layout.columns && layout.columns.minWidth && parseInt(layout.columns.minWidth)
      const minWidth = isActive ? `${layout.columns.minWidth}px` : null
      return minWidth
    },
    setBasicStyle () {
      const layoutData = this.itemSetting.layout
      const notStyles = ['options', 'link', 'division']
      const styles = Object.keys(layoutData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = layoutData[x]
        let filters = 'active'
        if (obj && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'link':
              break
            case 'background':
              filters = 'active' || 'dataId' || 'src' || 'value'
              styleObj['background-image'] = `url(${obj.value})`
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                if (o !== filters) {
                  if (o === 'value') {
                    styleObj[key] = value
                  }
                  styleObj[key] = value
                }
              })
              break
            case 'border':
              styleObj['border-width'] = '1px'
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                if (o !== filters) {
                  styleObj[key] = value
                }
              })
              break
            case 'padding':
              styleObj['padding-top'] = `${obj.tb}px`
              styleObj['padding-bottom'] = `${obj.tb}px`
              styleObj['padding-left'] = `${obj.lr}px`
              styleObj['padding-right'] = `${obj.lr}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
      })
      return styleObj
    },
    columns: {
      get () {
        return this.itemData.column
      },
      set (column) {
        const data = {
          id: this.id,
          moduleIndex: this.moduleIndex,
          column: column
        }
        this.$emit('changeColumn', data)
      }
    },
    getColumnAlignStyle () {
      const layout = this.itemSetting.layout
      const columns = layout && layout.columns
      const container = columns && columns.stretch ? 'stretch' : columns && columns.alignItems
      const item = container === 'stretch' ? columns.alignItems : null
      return {
        container: container,
        item: item
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    moduleStyle (style) {
      let result = {}
      if (this.getMaxWidth) {
        result = {
          ...result,
          maxWidth: this.getMaxWidth
        }
      }
      if (this.getColumnMinWidth) {
        result = {
          ...result,
          overflow: 'auto',
          flexWrap: 'nowrap',
          justifyContent: 'flex-start',
          minWidth: '100%',
          maxWidth: 'none'
        }
      }
      if (style) {
        result = {
          ...result,
          alignItems: this.getColumnAlignStyle && this.getColumnAlignStyle.container,
          ...style.padding && style.padding.lr === '0' && style.padding.lr === '0' && {
            margin: 0
          }
        }
      }
      return result
    },
    columnStyle (column) {
      const layoutData = column.detail
        ? column.flex
          ? { ...column.detail, flex: column.flex }
          : column.detail
        : {}
      const notStyles = ['link']
      const styles = Object.keys(layoutData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      const noColumnType = !(column.type.includes('division') || column.type.includes('button') || column.type.includes('image') || column.type.includes('carousel'))
      const getColumnMinWidth = this.getColumnMinWidth
      const columnAlignItems = this.getColumnAlignStyle && this.getColumnAlignStyle.item
      styles.forEach(function (x) {
        const obj = layoutData[x]
        let filters = 'active'
        if (obj && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'link':
              break
            case 'background':
              if (noColumnType) {
                filters = 'active' || 'dataId' || 'src' || 'value'
                styleObj['background-image'] = `url(${obj.value})`
                Object.keys(obj).forEach(function (o) {
                  key = `${x}-${o}`
                  value = obj[o]
                  if (o !== filters) {
                    if (o === 'value') {
                      styleObj[key] = value
                    }
                    styleObj[key] = value
                  }
                })
              }
              break
            case 'border':
              if (noColumnType) {
                styleObj['border-width'] = '1px'
                Object.keys(obj).forEach(function (o) {
                  key = `${x}-${o}`
                  value = obj[o]
                  if (o !== filters) {
                    styleObj[key] = value
                  }
                })
              }
              break
            case 'radius':
              if (noColumnType) {
                styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.br}px ${obj.bl}px`
              }
              break
            case 'padding':
              styleObj['padding-top'] = `${obj.tb}px`
              styleObj['padding-bottom'] = `${obj.tb}px`
              styleObj['padding-left'] = `${obj.lr}px`
              styleObj['padding-right'] = `${obj.lr}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
      })
      if (layoutData.flex) {
        styleObj.flex = layoutData.flex
      }
      if (getColumnMinWidth) {
        styleObj.minWidth = getColumnMinWidth
        styleObj.flex = 'none'
        styleObj.width = 'auto'
      }
      if (columnAlignItems) {
        styleObj.display = 'flex'
        styleObj.flexDirection = 'column'
        styleObj.justifyContent = columnAlignItems
      }
      return styleObj
    },
    updateCITE (target) {
      const html = target.value[this.activeLang]
      if (this.isNew) {
        Object.keys(target.value).forEach(function (lang) {
          target.value[lang] = html
        })
      }
      const fillValue = UTIL.fillLangs(target.value, target.value[this.activeLang])
      target.value = fillValue
    },
    reverseMix () {
      let chunk = this._.chunk(this.itemData.column, 2)
      let result = []
      chunk.forEach(function (x) {
        result.push((x.reverse()))
      })
      this.itemData.column = this._.flatten(result)
    },
    setColumn (columnName, isCopy) {
      const newColumnId = UNIQUE.mid()
      const columnData = this._.cloneDeep(this.moduleListAll.find(x => x.name === columnName).dataSet.column[0])
      const addColumn = this.itemData.column.concat({ ...columnData, columnId: newColumnId, flex: 1 })
      const data = {
        id: this.id,
        moduleIndex: this.moduleIndex,
        column: addColumn
      }
      this.$emit('changeColumn', data)
    },
    deleteColumn (columnId) {
      // 해당 컬럼을 삭제합니다.
      if (window.confirm(this.locale.confirm_delete_column)) {
        const data = {
          id: this.id,
          column: this.itemData.column.filter(x => x.columnId !== columnId)
        }
        this.$emit('changeColumn', data)
      }
    },
    setDetails (detail) {
      this.$emit('setDetail', detail)
    },
    setDetail (e, detail) {
      e.stopPropagation()
      const setbox = document.querySelectorAll('.setbox')
      const target = e.target.closest('.setbox')
      setbox.forEach(el => el.classList.remove('active'))
      target.classList.add('active')
      this.$emit('setDetail', detail)
    }
  }
}
</script>
